var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Grupo_853","data-name":"Grupo 853","transform":"translate(12.697 -5.158) rotate(90)"},React.createElement("path",{"id":"Trazado_1","data-name":"Trazado 1","d":"M-2.545-1.408,5.917,5.917l-2.869,3.1","transform":"translate(8.358 3)","fill":"none","stroke":"#809dca","strokeMiterlimit":"10","strokeWidth":"2","fillRule":"evenodd"})));
}

Tick.defaultProps = {"width":"11.861","height":"10.553","viewBox":"0 0 11.861 10.553"};

module.exports = Tick;

Tick.default = Tick;
